import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import s from './PromtBlocks.module.css';
import {
    selectImageLayout,
    selectImageProject,
    selectLoadingCreateLayout,
} from '../../../../store/selectors/imageSelectors';
import { setImageLayout } from '../../../../store/slices/imageSlice';

import IconLayoutOne from '../../../../shared/ui/icons/layouts/IconLayoutOne';
import IconLayoutTwo from '../../../../shared/ui/icons/layouts/IconLayoutTwo';
import IconLayoutThree from '../../../../shared/ui/icons/layouts/IconLayoutThree';
import IconLayoutFour from '../../../../shared/ui/icons/layouts/IconLayoutFour';
import IconLayoutFive from '../../../../shared/ui/icons/layouts/IconLayoutFive';
import IconLayoutSix from '../../../../shared/ui/icons/layouts/IconLayoutSix';
import IconLayoutSeven from '../../../../shared/ui/icons/layouts/IconLayoutSeven';
import IconLayoutEight from '../../../../shared/ui/icons/layouts/IconLayoutEight';
import IconLayoutNine from '../../../../shared/ui/icons/layouts/IconLayoutNine';
import IconLayoutTen from '../../../../shared/ui/icons/layouts/IconLayoutTen';
import IconLayoutEleven from '../../../../shared/ui/icons/layouts/IconLayoutEleven';
import IconLayoutTwelve from '../../../../shared/ui/icons/layouts/IconLayoutTwelve';
import IconLayoutThirteen from '../../../../shared/ui/icons/layouts/IconLayoutThirteen';
import IconLayoutFourteen from '../../../../shared/ui/icons/layouts/IconLayoutFourteen';
import Slider from '../../../../shared/ui/slider/Slider';
import { RgbaColorPicker } from 'react-colorful';
import { CollapsiblePanel } from '../../../../shared/ui/collapse-panel/CollapsiblePanel';
import Button from '../../../../shared/ui/button/Button';
import { createImageLayout } from '../../../../shared/api/imageLayoutApi';
import { updateImageLayout } from '../../../../shared/api/imageLayoutApi';
import { useAppDispatch } from '../../../../store/store';

import { ImageLayoutAttributes } from '../../../../shared/types/imageLayoutTypes';

type PanelKey = 'layout' | 'color' | 'gap';

export const LAYOUT_OPTIONS = [
    {
        slug: 'none',
        icon: <div />,
        slot_count: 1,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutOne',
        icon: <IconLayoutOne />,
        slot_count: 2,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutTwo',
        icon: <IconLayoutTwo />,
        slot_count: 2,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutThree',
        icon: <IconLayoutThree />,
        slot_count: 2,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutFour',
        icon: <IconLayoutFour />,
        slot_count: 3,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutFive',
        icon: <IconLayoutFive />,
        slot_count: 4,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutSix',
        icon: <IconLayoutSix />,
        slot_count: 6,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutSeven',
        icon: <IconLayoutSeven />,
        slot_count: 9,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutEight',
        icon: <IconLayoutEight />,
        slot_count: 4,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutNine',
        icon: <IconLayoutNine />,
        slot_count: 5,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutTen',
        icon: <IconLayoutTen />,
        slot_count: 5,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutEleven',
        icon: <IconLayoutEleven />,
        slot_count: 4,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutTwelve',
        icon: <IconLayoutTwelve />,
        slot_count: 3,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutThirteen',
        icon: <IconLayoutThirteen />,
        slot_count: 4,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
    {
        slug: 'LayoutFourteen',
        icon: <IconLayoutFourteen />,
        slot_count: 2,
        canvas_color: { red: 255, green: 255, blue: 255, gradient: 'none', transparency: 100 },
        gap_size: 10,
    },
];

export default function LayoutBlock() {
    const dispatch = useAppDispatch();
    const imageLayout = useSelector(selectImageLayout);
    const imageProject = useSelector(selectImageProject);
    const loadingCreateLayout = useSelector(selectLoadingCreateLayout);
    const [openPanels, setOpenPanels] = useState<PanelKey[]>([]);

    console.log('imageLayout', imageLayout);

    const createLayout = () => {
        dispatch(
            createImageLayout({
                imageProjectId: imageProject?.id ?? '',
                layout: {
                    slug: 'none',
                    order: 1,
                    canvas_color: {
                        red: 255,
                        green: 255,
                        blue: 255,
                        gradient: 'none',
                        transparency: 100,
                    },
                    gap_size: 10,
                    inline_text: [],
                    transformation: {
                        presets: {
                            size: 'none',
                            aspect_ratio: 'none',
                        },
                        width: 500,
                        height: 700,
                        rotation: 0,
                        flip: 'none',
                    },
                },
            }),
        );
    };

    if (!imageLayout)
        return (
            <Button
                style={{ backgroundColor: '#FFE100' }}
                text="Slide Show"
                onClick={createLayout}
            />
        );

    const togglePanel = (key: PanelKey) =>
        setOpenPanels((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
        );

    const handleColorChange = (color: { r: number; g: number; b: number; a: number }) => {
        dispatch(
            setImageLayout({
                ...imageLayout,
                canvas_color: {
                    red: color.r,
                    green: color.g,
                    blue: color.b,
                    gradient:
                        'linear-gradient(159deg,rgba(189, 96, 146, 0.64) 0%, rgba(0, 0, 0, 0.73) 100%);',
                    transparency: color.a * 100,
                },
            }),
        );
    };

    const handleGapChange = (value: number) => {
        dispatch(setImageLayout({ ...imageLayout, gap_size: value }));
    };

    console.log('loadingCreateLayout', loadingCreateLayout);

    const handleLayoutChange = (option: (typeof LAYOUT_OPTIONS)[number]) => {
        const newLayout = {
            id: imageLayout?.id ?? '',
            slug: option.slug,
            slot_count: option.slot_count,
            canvas_color: option.canvas_color,
            order: imageLayout?.order ?? 1,
            gap_size: 10,
            transformation: imageLayout?.transformation ?? {
                width: 100,
                height: 100,
                rotation: 0,
                flip: { horizontal: false, vertical: false },
            },
            images: imageLayout?.images ?? [],
            inline_text: imageLayout?.inline_text ?? [],
        };

        dispatch(
            updateImageLayout({
                imageProjectId: imageProject?.id ?? '',
                layoutId: imageLayout.id,
                layout: newLayout,
            }),
        );

        dispatch(setImageLayout(newLayout));
    };

    return (
        <div className={s.container}>
            <CollapsiblePanel
                title="Image Layouts"
                isOpen={openPanels.includes('layout')}
                onToggle={() => togglePanel('layout')}
            >
                <div className={s.grid}>
                    {LAYOUT_OPTIONS.map((option) => (
                        <div
                            key={option.slug}
                            className={`${s.card} ${imageLayout.slug === option.slug ? s.active : ''}`}
                            style={{ width: '84px', height: '84px' }}
                            onClick={() => handleLayoutChange(option)}
                        >
                            {option.icon}
                            {option.slug === 'none' && <p className={s.label}>None</p>}
                        </div>
                    ))}
                </div>
            </CollapsiblePanel>

            <CollapsiblePanel
                title="Canvas Color"
                isOpen={openPanels.includes('color')}
                onToggle={() => togglePanel('color')}
            >
                <div className={s.block_container}>
                    <RgbaColorPicker
                        color={{
                            r: imageLayout.canvas_color.red,
                            g: imageLayout.canvas_color.green,
                            b: imageLayout.canvas_color.blue,
                            a: imageLayout.canvas_color.transparency / 100,
                        }}
                        style={{ width: '100%' }}
                        onChange={handleColorChange}
                    />
                </div>
            </CollapsiblePanel>

            <CollapsiblePanel
                title="Image Gap"
                isOpen={openPanels.includes('gap')}
                onToggle={() => togglePanel('gap')}
            >
                <div className={s.slider_container}>
                    <Slider
                        value={imageLayout.gap_size || 0}
                        min={0}
                        max={100}
                        step={1}
                        onChange={handleGapChange}
                    />
                </div>
            </CollapsiblePanel>
            <Button
                style={{ backgroundColor: '#FFE100' }}
                text="Slide Show"
                onClick={createLayout}
                state={loadingCreateLayout ? 'loading' : 'enabled'}
            />
        </div>
    );
}
